/**
 * @description check ingore url for loading in interceptor
 * @param req requst
 */
export function IsIgnoreUrlForLoading(req) {
  if (
    !(req.url.includes('public/fcm')) &&
    !(req.url.includes('post/outOfDatePostsSearch')) &&
    !(req.url.includes('post/notFreePostsSearch')) &&
    !(req.url.includes('post/comment')) &&
    !(req.url.includes('post/linkedMagazine/all')) &&
    !(req.url.includes('post/linkedCatalog/all')) &&
    !(req.url.includes('region/subCategory/all')) &&
    !(req.url.includes('category/subCategory/all')) &&
    !(req.url.includes('admin/post/specific')) &&
    !(req.url.includes('ticket/specialUser/details')) &&
    !(req.url.includes('admin/ticket/all')) &&
    !(req.url.includes('users/ticket/details')) &&
    !(req.url.includes('user/common/specific'))
  ) {
    return true;
  } else {
    return false;
  }
}
